import React from 'react';
import { Tag } from 'antd';
import {
  buildStatusPillStyle,
  getDeliveryStatusPillColors,
} from '../statusTagColors';

interface DeliveryStatusTagProps {
  status?: string | null;
  className?: string;
  style?: React.CSSProperties;
}

const DeliveryStatusTag: React.FC<DeliveryStatusTagProps> = ({
  status,
  className,
  style,
}) => {
  const colors = getDeliveryStatusPillColors(status);

  return (
    <Tag
      className={className}
      style={buildStatusPillStyle(colors, {
        borderRadius: 4,
        fontSize: 10,
        fontWeight: '600',
        textTransform: 'capitalize',
        ...style,
      })}
    >
      {status || 'Unknown'}
    </Tag>
  );
};

export default DeliveryStatusTag;
